import { render } from "./ConfirmIdentityPage.vue?vue&type=template&id=20db5536&ts=true"
import script from "./ConfirmIdentityPage.vue?vue&type=script&lang=ts"
export * from "./ConfirmIdentityPage.vue?vue&type=script&lang=ts"

import "./ConfirmIdentityPage.vue?vue&type=style&index=0&id=20db5536&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__